// Lines to say aloud while the loading screen takes a new version into use (shell/UpdateGate.tsx;
// Axel 2026-10-21). Every line is Peterson's own: an example sentence of the wiki as the built
// bundle has it (`id` = its example id), with its Finnish as the bundle holds it, checked or
// reviewed, never a draft. update-lines.test.ts fails when a line or its Finnish drifts from the
// bundle. No stress marks: several lines are commands, whose stress the plain rule gets wrong.
export interface UpdateLine {
  id: string;
  hv: string;
  fi: string;
}

export const UPDATE_LINES: readonly UpdateLine[] = [
  { id: 'ex-77f57d4c648f', hv: 'Valar morghūlis.', fi: 'Kaikkien ihmisten on kuoltava.' },
  { id: 'ex-20ad58476cfa', hv: 'Sȳraks! Īlot sōvegon!', fi: 'Syrax! Lennämme!' },
  { id: 'ex-9f76efae3b52', hv: 'Perzys zaldrīzī sēnagon kostos daor.', fi: 'Tuli ei voi tappaa lohikäärmettä.' },
  { id: 'ex-8f8f2d90634a', hv: 'Zaldrīzes buzdari iksos daor.', fi: 'Lohikäärme ei ole orja.' },
  { id: 'ex-809b34b2bbbb', hv: 'Zaldrīzesse biādroti elēnȳti zūgusy daor.', fi: 'Lohikäärmeet eivät pelkää lampaiden mielipiteitä.' },
  { id: 'ex-190cce99a614', hv: 'Dovaogēdys! Naejot memēbātās!', fi: 'Tahrattomat! Eteenpäin mars!' },
  { id: 'ex-3f3d6c3c6cc1', hv: 'Sōnar amāzis. Zōbrȳmi vējomē.', fi: 'Talvi on tulossa, pimeyden ja tuhon kera.' },
  { id: 'ex-3ec6b2e6a768', hv: 'Yn vīlībāzma tetos daor.', fi: 'Mutta sota ei ole ohi.' },
  { id: 'ex-8d0d86d40065', hv: 'Zaldrīzo ānogar', fi: 'Lohikäärmeen veri' },
  { id: 'ex-43ac60369399', hv: 'Kīviō dārilaros ñurho ānogro henumāzis.', fi: 'Minun verestäni syntyy luvattu prinssi.' },
  { id: 'ex-765c6b588083', hv: 'Sepār jelmāzma spȳdas, se zaldrīzesse liltis.', fi: 'Sitten myrsky puhkesi, ja lohikäärmeet tanssivat.' },
  { id: 'ex-997ced0d2cd6', hv: 'Ērinnot Dārīs!', fi: 'Voittoon, kuningattaret!' },
  { id: 'ex-561082653c1d', hv: 'Jaehossas sȳris sātās.', fi: 'Olkoot jumalat suosiollisia!' },
  { id: 'ex-5916983827ae', hv: 'Zīrtys perzys', fi: 'Jäätynyt tuli' },
  { id: 'ex-7a59e60bfb9f', hv: 'Uēpo Valyrio Prūmia Iksi.', fi: 'Me olemme Vanhan Valyrian sydän.' },
  { id: 'ex-10026cb8c937', hv: 'Mirrun mōrqitto bantiot sikiks.', fi: 'Jotkut syntyvät loputtomaan yöhön.' },
  { id: 'ex-43a70d47be7d', hv: 'Vȳs verdlios perzomy siglitaks!', fi: 'Tulesta hän syntyi uudelleen tehdäkseen maailmasta uuden!' },
  { id: 'ex-7ceedc757af1', hv: 'Ñuhi zaldrīzī belmurzi!', fi: 'He kahlitsevat lohikäärmeitäni!' },
  { id: 'ex-9d1b7ab86863', hv: 'Skoriot ñuhyz zaldrīzesse issi?!', fi: 'Missä ovat lohikäärmeeni?!' },
  { id: 'ex-8b320fbed15d', hv: 'Dorolvī vali zaldrīzī sēntis.', fi: 'Harva mies on tappanut lohikäärmeen.' },
  { id: 'ex-1cd23ccb2085', hv: 'Aōhor jaqiarzir ivīlībin imorghūlīn, jaqiarzus Dārȳs.', fi: 'Taistelen ja kuolen kunniasi puolesta, oi kunniakas kuningatar.' },
  { id: 'ex-252040e68287', hv: 'Zaldrīzesse vōskyzy issi.', fi: 'Lohikäärmeet ovat pyhiä.' },
];

/** How long one line stays (a calm read and one go at saying it aloud). */
export const LINE_MS = 5000;
